module.exports = __webpack_public_path__ + "static/media/Leader Scoreboard YELLOW CROWN.aa7eaecd.svg";